<template>
  <div class="currency">
    <div class="octobus__field">
      <div class="octobus__control" :class="customClass">
        <div class="octobus__select is-primary is-medium is-fullwidth-mobile">
          <select
            name="currency"
            class="is-fullwidth-mobile"
            id="currency"
            v-model="selected"
            @change="setSelectedCurrency($event.target.value)"
          >
            <template v-if="currencyList.length">
              <option
                :value="currency.id"
                :key="currency.id"
                v-for="currency in currencyList"
              >{{currency.id}}</option>
            </template>
            <option v-else value="loading">{{$t('currency.loading')}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Currency',
  props: {
    customClass: {
      type: String,
      default() {
        return '';
      },
    },
    currencyList: {
      type: Array,
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  methods: {
    setSelectedCurrency(value) {
      this.selected = value;
      localStorage.setItem('__octobus__search-currency', value);
      this.setCurrencyName();
      this.$emit('setCurrency', value);
    },
    setCurrencyName() {
      this.$root.octobusCurrency = this.currencyList.find(item => item.id === this.selected);
      localStorage.setItem('__octobus__current-currency', JSON.stringify(this.$root.octobusCurrency));
    },
  },
  created() {
    this.setSelectedCurrency(localStorage.getItem('__octobus__search-currency'));
  },
};
</script>

<style lang="scss">
/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {
  #app, #auth {
    .is-fullwidth-mobile {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_common/Currency.vue